import { parseCategoryPath, type CategoryPath } from "./category-path";

export const LISTING_PAGE_SIZE = 24;

// Revisit with data: a deeper link renders every product above it, so the cap bounds the page weight.
export const MAX_LISTING_PAGES = 5;

export const LISTING_PAGE_PARAM = "page";

const DEPTH_SEGMENT = "page";
const WHOLE_NUMBER = /^\d+$/;

/** A category path, and how many pages of its listing the shopper has loaded. */
export interface ListingPath extends CategoryPath {
	pages: number;
}

/** Reads `?page=` as a count of loaded pages; past the cap it clamps to the cap. */
export function parseListingPages(
	value: string | null | undefined
): number | undefined {
	if (!value || !WHOLE_NUMBER.test(value)) return undefined;
	const pages = Number(value);
	return pages >= 1 ? Math.min(pages, MAX_LISTING_PAGES) : undefined;
}

// `?page=N` is served from `/shop/<super>/<category>/page/<N>` so each depth caches like any page.
export function parseListingPath(
	segments: readonly string[] | undefined
): ListingPath | null {
	if (segments?.length === 4 && segments[2] === DEPTH_SEGMENT) {
		const path = parseCategoryPath(segments.slice(0, 2));
		const pages = parseListingPages(segments[3]) ?? 0;
		const isServedDepth = pages > 1 && String(pages) === segments[3];
		return path?.categorySlug && isServedDepth ? { ...path, pages } : null;
	}

	const path = parseCategoryPath(segments);
	return path ? { ...path, pages: 1 } : null;
}

export function toListingDepthPath(pathname: string, pages: number): string {
	return `${pathname}/${DEPTH_SEGMENT}/${pages}`;
}
